import React, { FC, ReactElement } from 'react';
import { Maybe } from '../../gatsby-types';

type Props = Readonly<{
  description: Maybe<string>;
}>;

export const TegeDescription: FC<Props> = ({ description }): ReactElement => {
  return <p className='text-gray-700 text-base'>{description}</p>;
};
